import React from 'react'
import { Link } from 'react-router-dom'
import { withStatusCode } from '#src/containers/Router'
import { Button } from '@deal/components'
import BrandAwareLogo from '#src/components/Logo'
import styles from './styles.css'

const NotFound = () => (
  <section>
    <header className={styles.header}>
      <Link to="/" className={styles.logo}>
        <BrandAwareLogo mark="combo" color="dark" className={styles.desktopIcon} />
        <BrandAwareLogo mark="icon" color="dark" className={styles.mobileIcon} />
      </Link>
    </header>
    <div className={styles.code}>403</div>
    <h1 className={styles.headline}>This page is forbidden.</h1>
    <div className={styles.button}>
      <Link to="/">
        <Button className={styles.darkButton}>Take me home</Button>
      </Link>
    </div>
  </section>
)

export default withStatusCode(403)(NotFound)
